import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export const requiredAndWithoutSpaces = (control: AbstractControl): ValidationErrors | null => {
  const value = control?.value as string;
  if (!value || value.trim() === '') {
    return { required: true };
  }
  return Validators.required(control);
};
